import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { Plot } from '../shape/plot';
import { Shape } from '../shape/shape.interface';

interface PlotDetails {
    crop: string;
    program: string;
    studyName: string;
    environmentNumber: string;
    germplasmName: string;
    replicate: string;
    block: string;
    rowCol: string;
    plotNumber: string;
}

@Component({
    selector: 'jhi-plot-details-view',
    templateUrl: './plot-details-view.component.html',
    styleUrls: ['./plot-details-view.component.scss']
})
export class PlotDetailsViewComponent implements OnInit, OnChanges {

    @Input() shape?: Shape;
    @Input() details?: PlotDetails;

    static toUpper(str: string): string {
        return (str || '').toUpperCase();
    }

    constructor() {
    }

    ngOnInit(): void {
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (this.shape) {
            const plot = this.shape as Plot;

            this.details = new class implements PlotDetails {
                crop: string;
                program: string;
                studyName: string;
                environmentNumber: string;
                block: string;
                germplasmName: string;
                plotNumber: string;
                replicate: string;
                rowCol: string;
            };

            if (plot.observationUnit) {
                plot.observationUnit.observationUnitPosition.observationLevelRelationships.forEach((levels) => {
                    if (PlotDetailsViewComponent.toUpper(levels.levelName) === 'REP') {
                        this.details.replicate = levels.levelCode;
                    } else if (PlotDetailsViewComponent.toUpper(levels.levelName) === 'BLOCK') {
                        this.details.block = levels.levelCode;
                    } else if (PlotDetailsViewComponent.toUpper(levels.levelName) === 'PLOT') {
                        this.details.plotNumber = levels.levelCode;
                    }
                });

                this.details.crop = plot.crop;
                this.details.program = plot.observationUnit.programName;
                this.details.studyName = plot.observationUnit.trialName;
                this.details.environmentNumber = plot.parentStudy.environmentNumber;
                this.details.germplasmName = plot.observationUnit.germplasmName;
                this.details.rowCol = `${plot.observationUnit.observationUnitPosition.positionCoordinateX} , ${plot.observationUnit.observationUnitPosition.positionCoordinateY}`;
            }

        }
    }

}
